<nz-layout [style.width]="(!!readonly ? 660 : 750)  + 'px'">
    <projects-profiles-volume *ngIf="!!root.id" [root]="root" [regular]="false" [readonly]="readonly"
        (onVolumeSelectedChange)="onVolumeSelectedChange($event)" (onVolumeChange)="onVolumeListChange($event)"
        (onFileSynced)="onFileSynced()">
    </projects-profiles-volume>
</nz-layout>
<nz-layout [style.width]="'calc(100% - ' + (!!readonly ? 660 : 750) + 'px)'">
    <nz-content class="table-container">
        <div class="table-wrapper" (scroll)="onScroll($event)" (scrollend)="onScrollEnd($event)" #scroll>
            <table-pro [config]="config!" [currentPage]="pager.pageIndex" [currentPageSize]="pager.pageSize"
                [tableData]="[]" (calcResultChange)="calcResultChange($event)"
                (firstSortOrderKeyChange)="firstSortOrderKeyChange($event)"
                (queryPanelStateChange)="queryPanelStateChange($event)" (resetClick)="resetSearch($event)"
                (searchClick)="searchClick($event)" (checkChange)="checkChange($event)" [stickyTop]="40"
                (afterEdit)="afterEdit($event)">
                <div class="grid overview">
                    <div class="row">
                        <div class="column no-border color-danger text-left left-sticky" [style.width]="'10rem'"
                            [style.left]="0">
                            <!-- TODO:  -->
                            <input type="checkbox" [(ngModel)]="showNotArchivingFile"
                                (ngModelChange)="onShowNotArchivingFileChange()" [disabled]="readonly" />
                            显示未归卷：{{root.notArchivingFileCount}}份
                        </div>
                        <div class="column no-border color-primary left-sticky" [style.width]="'30rem'"
                            [style.left]="'10rem'">
                            文件库列表
                        </div>
                        <!-- <div class="column no-border color-primary left-sticky" [style.width]="'10rem'">
                            <button class="color-primary" nz-button nzType="text" (click)="uploadOfflineVolume()">+
                                线下案卷(扫描件)</button>
                        </div>
                        <div class="column no-border color-primary left-sticky" [style.width]="'10rem'">
                            <button class="color-primary" nz-button nzType="text" (click)="downloadVolumeTemp()">↓
                                案卷目录模板</button>
                        </div> -->
                    </div>
                </div>

                <div body>
                    <table [style.left]="0" [style.width]="totalWidth + 'px'">
                        <colgroup>
                            <col span="1" *ngFor="let item of config?.columns ?? []"
                                [style.width]="(item.width * 100 / totalWidth) + '%'">
                        </colgroup>
                        <tr *ngFor="let item of recordList ?? []; let index = index;">
                            <td class="{{readonly ? '' : 'editable'}} left-sticky" [style.textAlign]="'center'"
                                [style.left]="0">
                                <format-data class="{{!item.volumeIdTarget ? 'color-danger' : 'color-primary'}}"
                                    [contentStr]="!!item.volumeIdTarget && volumeMap[item.volumeIdTarget] ? volumeMap[item.volumeIdTarget].sortOrderLabel!  : '未归卷'">
                                    <select *ngIf="!readonly" class="transparent" [(ngModel)]="item.volumeIdTarget"
                                        (ngModelChange)="onSortOrderChange(item)">
                                        <option *ngFor="let volume of volumeSortOrderOpts" [value]="volume.value">
                                            {{volume.label}}
                                        </option>
                                    </select>
                                </format-data>
                            </td>
                            <td class="{{!!+item.volumeId! && !readonly ? 'editable' : ''}} left-sticky"
                                [style.left]="60 + 'px'">
                                <input *ngIf="item.volumeFileSortOrder !== undefined && item.volumeId && !readonly"
                                    type="text" [(ngModel)]="item.volumeFileSortOrderTarget"
                                    [style.textAlign]="'center'" (blur)="onVolumeFileSortOrderChange(item)"
                                    appDigitalFormat>

                                <span *ngIf="readonly">{{item.volumeFileSortOrderTarget ?? ''}}</span>
                            </td>
                            <td class="{{readonly ? '' : 'editable'}} left-sticky" [style.left]="110 + 'px'">
                                <format-data [contentStr]="item.fileTitle ?? ''" [patternStr]="'E+200'"
                                    (click)="editColumn('fileTitle' + index)">
                                    <input *ngIf="!readonly" type="text" [(ngModel)]="item.fileTitle"
                                        class="{{editing['fileTitle' + index] || item.fileTitle === undefined || item.fileTitle + '' === ''? '' : 'transparent'}}"
                                        (blur)="onFileEdit(item)" />
                                </format-data>
                            </td>
                            <td class="clickable color-primary" (click)="sign(item.workFlowKey)">
                                <format-data [contentStr]="item.formSn ?? ''" [patternStr]="'E+120'">
                                </format-data>
                            </td>
                            <td>
                                <format-data [contentStr]="(item.formCode ?? '') + ' ' + (item.formName ?? '')"
                                    [patternStr]="'E+140'">
                                </format-data>
                            </td>
                            <td>
                                <format-data [contentStr]="item.materialTypeNames ?? ''" [patternStr]="'E+100'">
                                </format-data>
                            </td>
                            <td class="{{readonly ? '' : 'editable'}}">
                                <nz-date-picker [(ngModel)]="item.submitDateDate" [nzFormat]="'yyyy-MM-dd'"
                                    [nzDisabled]="readonly" [nzPlaceHolder]="' '" [nzSuffixIcon]="''"
                                    (ngModelChange)="onFileEdit(item)">
                                </nz-date-picker>
                            </td>
                            <td class="{{readonly ? '' : 'editable'}}">
                                <nz-date-picker [(ngModel)]="item.finishDateDate" [nzFormat]="'yyyy-MM-dd'"
                                    [nzDisabled]="readonly" [nzPlaceHolder]="' '" [nzSuffixIcon]="''"
                                    (ngModelChange)="onFileEdit(item)">
                                </nz-date-picker>
                            </td>
                            <td *ngIf="!!hasSelf">
                                <format-data class="clickable color-primary"
                                    [contentStr]="item.standardTestSelfReportSn ?? ''" [patternStr]="'E+100'"
                                    (click)="sign(item.workFlowKey)">
                                </format-data>
                            </td>
                            <td>
                                <format-data class="clickable color-primary"
                                    [contentStr]="item.standardTestSpotReportSn ?? ''" [patternStr]="'E+100'"
                                    (click)="sign(item.workFlowKey)">
                                </format-data>
                            </td>
                            <td
                                class="{{item.fileStatus !== ArchiveFileStatus.OK && item.fileStatus !== ArchiveFileStatus.ERROR && item.fileStatus !== ArchiveFileStatus.UPDATE || readonly ? '' : 'editable'}}">
                                <format-data *ngIf="item.fileStatus"
                                    class="{{item.fileStatus === ArchiveFileStatus.OK ? 'color-success' : 'color-danger'}}"
                                    [contentStr]="ArchiveFileStatusMap[item.fileStatus!]">
                                    <select [(ngModel)]="item.fileStatus" (ngModelChange)="onFileEdit(item)"
                                        *ngIf="!readonly" [style.appearance]="'none'" class="transparent"
                                        [disabled]="item.fileStatus !== ArchiveFileStatus.OK && item.fileStatus !== ArchiveFileStatus.ERROR && item.fileStatus !== ArchiveFileStatus.UPDATE">
                                        <option [value]="ArchiveFileStatus.OK">
                                            {{ ArchiveFileStatusMap[ArchiveFileStatus.OK] }}
                                        </option>
                                        <option [value]="ArchiveFileStatus.ERROR">
                                            {{ ArchiveFileStatusMap[ArchiveFileStatus.ERROR] }}
                                        </option>
                                        <option [value]="ArchiveFileStatus.UPDATE" [disabled]="true">
                                            {{ ArchiveFileStatusMap[ArchiveFileStatus.UPDATE] }}
                                        </option>
                                    </select>
                                </format-data>
                            </td>
                            <td class="{{readonly ? '' : 'editable'}}">
                                <input *ngIf="!readonly" class="color-danger" type="text" [(ngModel)]="item.comment"
                                    (blur)="onFileEdit(item)" />

                                <format-data *ngIf="!!readonly" class="color-primary" [contentStr]="item.comment ?? ''"
                                    [patternStr]="'E+120'">
                                </format-data>

                            </td>
                            <td *ngIf="!readonly">
                                <div class="line">
                                    <span
                                        class="fake-btn {{!item.volumeId || !item.volumeFileId || !volumeMap[item.volumeId] || volumeMap[item.volumeId].status !== ArchiveStatus.UNLOCK ? 'color-light' : 'color-primary'}}"
                                        (click)="moveUp(item)">
                                        ↑
                                    </span>
                                    <span
                                        class="fake-btn {{!item.volumeId || !item.volumeFileId || !volumeMap[item.volumeId] || volumeMap[item.volumeId].status !== ArchiveStatus.UNLOCK ? 'color-light' : 'color-primary'}}"
                                        (click)="moveDown(item)">
                                        ↓
                                    </span>
                                    <span
                                        class="fake-btn {{!item.volumeId || !item.volumeFileId || !volumeMap[item.volumeId] || volumeMap[item.volumeId].status !== ArchiveStatus.UNLOCK ? 'color-light' : 'color-primary'}}">
                                        +
                                        <input type="file"
                                            [disabled]="!item.volumeId || !item.volumeFileId || !volumeMap[item.volumeId] || volumeMap[item.volumeId].status !== ArchiveStatus.UNLOCK"
                                            (change)="insertFile($event,index)" accept=".pdf">
                                    </span>
                                    <span class="fake-btn color-primary" (click)="remove(index)">
                                        {{item.recordSource === RecordSource.MANUAL ? '删除' : '移除'}}
                                    </span>
                                </div>
                            </td>
                            <td>
                                <span>{{item.filePageCount}}</span>｜<span
                                    class="color-light">{{item.attachFileCount}}-{{item.attachFilePageCount}}</span>｜<span>{{(+item.fileSize!
                                    + +item.attachFileSize!) | fileSize}}</span>
                            </td>
                        </tr>
                    </table>
                </div>

            </table-pro>
        </div>
    </nz-content>
    <nz-footer class="footer">
        <nz-pagination class="footer-left" [nzPageIndex]="pager.pageIndex" [(nzPageSize)]="pager.pageSize"
            [nzPageSizeOptions]="pager.pageSizeOptions" [nzTotal]="pager.total" nzShowQuickJumper
            [nzShowSizeChanger]="true" [nzShowQuickJumper]="true" (nzPageIndexChange)="pageIndexChange($event)"
            (nzPageSizeChange)="pageSizeChange($event)">
        </nz-pagination>
    </nz-footer>
</nz-layout>



<ng-template appHost></ng-template>